export interface IWarningModalModel {
  message: string;
  errorCode: string;
  header: string;
}

export class WarningModalModel implements IWarningModalModel {
  constructor(
    public message: string = "",
    public errorCode: string = "",
    public header: string = "Felaktig scan"
  ) {}
}
